import { useTranslation } from "next-i18next";
import { IconFilledStar } from "src/components/icons-mui/filled-star";
import { IconOutlineStar } from "src/components/icons-mui/outline-star";
import { Button } from "src/components-mui/base/button/button";
import { useUnderlyingFollowing } from "src/hooks/following/use-underlying-following";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { useUserStore } from "src/stores/user-store";

interface IUnderlyingFollowButtonProps {
    underlyingIsin: string;
}

export const UnderlyingFollowButton = ({ underlyingIsin }: IUnderlyingFollowButtonProps) => {
    const { t } = useTranslation("common");
    const { isLoggedIn } = useUserStore();
    const { openLoginModal } = useLinkBuilder();
    const { isFollowed, toggleIsFollowed } = useUnderlyingFollowing({ underlyingIsin });
    const IconStar = isFollowed ? IconFilledStar : IconOutlineStar;

    const handleClick = () => {
        if (!isLoggedIn) {
            void openLoginModal();
            return;
        }

        toggleIsFollowed();
    };

    return (
        <Button variant="outlined" size="small" startIcon={<IconStar sx={{ width: "24px", height: "24px", mr: 1 }} />} onClick={handleClick}>
            {t(isFollowed ? "unfollow" : "follow")}
        </Button>
    );
};
